import styled from 'styled-components'

import { transition } from '../../../../../utils/style-utils'

interface Props {
  transitioning: boolean
  active: boolean
  clickable?: boolean
}

export const SlideContainer = styled.div<Props>`
  overflow: hidden;
  position: absolute;
  height: 100%;
  width: 100%;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  z-index: ${({ active }) => (active ? '1' : '0')};
  display: ${({ transitioning, active }) => (!transitioning && !active ? 'transparent' : 'inherit')};
  opacity: ${({ active }) => (active ? '1' : '0')};
  ${transition('opacity', 0.5)};
`
